var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_c('br'),_vm._v("  "),_c('br'),_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v(_vm._s(_vm.message)+"!")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }